import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js'
import SwiperCore, { Pagination, A11y, Autoplay } from 'swiper'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import './style.scss'

import { SIZE_IMAGE } from '_utils/constant'

SwiperCore.use([Pagination, A11y, Autoplay])

const PlaceholderSVG = () => (
  <div className='img-slider__placeholder' aria-hidden='true'>
    <svg width='36' height='36' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='3' y='3' width='18' height='18' rx='2' stroke='currentColor' strokeWidth='1.5' />
      <circle cx='8.5' cy='8.5' r='1.5' fill='currentColor' />
      <path
        d='M21 15L16 10L5 21'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </div>
)

const ImageSlider = ({
  images = [],
  alt = '',
  height = SIZE_IMAGE,
  className = '',
  autoplay = true,
  autoplayDelay = 3000,
}) => {
  const containerStyle = { height }

  if (!images.length) {
    return (
      <div className={`img-slider img-slider--empty ${className}`} style={containerStyle}>
        <PlaceholderSVG />
      </div>
    )
  }

  if (images.length === 1) {
    return (
      <div className={`img-slider ${className}`} style={containerStyle}>
        <img
          className='img-slider__img'
          src={images[0]}
          alt={alt}
          loading='lazy'
        />
      </div>
    )
  }

  return (
    <div className={`img-slider ${className}`} style={containerStyle}>
      <Swiper
        pagination={{ clickable: true }}
        loop
        autoplay={
          autoplay
            ? {
                delay: autoplayDelay,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false
        }
        className='img-slider__swiper'
      >
        {images.map((url, i) => (
          <SwiperSlide key={url}>
            <img
              className='img-slider__img'
              src={url}
              alt={`${alt} ${i + 1}`}
              loading='lazy'
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

ImageSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
  alt: PropTypes.string,
  height: PropTypes.number,
  className: PropTypes.string,
  autoplay: PropTypes.bool,
  autoplayDelay: PropTypes.number,
}

export default ImageSlider
